import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import QuoteModal from '../common/QuoteModal';

const CategoryCTA = ({ categoryName }) => {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  
  // Background image path - easily customizable
  const backgroundImage = '/images/hero-background4.jpeg';

  return (
    <>
      <section 
        className="relative py-16 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${backgroundImage})`
        }}
      >
        {/* Blue gradient overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-br from-catalina-blue/90 to-san-marino/90"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            {/* Main CTA Content */}
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Ready to Get Started?
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              {categoryName 
                ? `Get a customized quote for our ${categoryName} products or speak with our experts to find the perfect solution for your needs.`
                : 'Get a customized quote or speak with our experts to find the perfect solution for your needs.'
              }
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
              <button
                onClick={() => setIsQuoteModalOpen(true)}
                className="bg-white text-catalina-blue px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 w-full sm:w-auto"
              >
                Request a Quote
              </button>
              <Link
                to="/contact"
                className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-catalina-blue transition duration-300 w-full sm:w-auto"
              >
                Contact Us
              </Link>
            </div>

            {/* Additional Info */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12 pt-12 border-t border-white/20">
              <div className="flex flex-col items-center">
                <svg className="w-12 h-12 mb-4 text-white/90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <h3 className="text-lg font-semibold mb-2">Expert Consultation</h3>
                <p className="text-white/80 text-sm">
                  Speak with our product specialists
                </p>
              </div>

              <div className="flex flex-col items-center">
                <svg className="w-12 h-12 mb-4 text-white/90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <h3 className="text-lg font-semibold mb-2">Quality Guaranteed</h3>
                <p className="text-white/80 text-sm">
                  Premium products with warranty
                </p>
              </div>

              <div className="flex flex-col items-center">
                <svg className="w-12 h-12 mb-4 text-white/90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
                <h3 className="text-lg font-semibold mb-2">Fast Delivery</h3>
                <p className="text-white/80 text-sm">
                  Quick turnaround on all orders
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quote Modal */}
      <QuoteModal 
        isOpen={isQuoteModalOpen}
        onClose={() => setIsQuoteModalOpen(false)}
      />
    </>
  );
};

export default CategoryCTA;